
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"96","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".5","fill":"#fff"}},[_c('path',{attrs:{"d":"M56.51 21.557c-2.979-.014-4.55-2.062-4.55-5.105V6.4h3.058v3.07h1.838v2.741h-1.838v4.266c0 1.687.765 2.32 2.293 2.226.812 1.654 1.96 2.533 1.96 2.533-1.396.398-2.76.32-2.76.32z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.022 20.38c.902.934 2.08 1.402 3.466 1.402 3.142 0 5.684-2.827 5.684-6.309 0-3.458-2.518-6.285-6.1-6.285-3.604 0-6.122 2.827-6.122 6.285V25.6h3.072v-5.22zm0-4.907c0-1.87 1.364-3.388 3.05-3.388 1.687 0 3.05 1.449 3.05 3.388 0 1.963-1.363 3.459-3.05 3.459-1.686 0-3.05-1.542-3.05-3.459zM66.978 21.526h2.888V15.52c0-3.481-2.519-6.332-6.1-6.332-3.603 0-6.123 2.85-6.123 6.332 0 3.458 2.566 6.262 5.707 6.262 1.433 0 2.727-.514 3.628-1.518v1.262zm-6.261-5.982c0-1.987 1.363-3.459 3.049-3.459 1.687 0 3.05 1.542 3.05 3.459 0 1.869-1.363 3.388-3.05 3.388-1.686 0-3.05-1.472-3.05-3.388zM32.191 21.861c3.345 0 6.082-2.715 6.082-6.352 0-3.636-2.737-6.4-6.082-6.4-3.345 0-6.058 2.764-6.058 6.4 0 3.637 2.713 6.352 6.058 6.352zm0-9.894c1.638 0 2.97 1.464 2.97 3.566 0 2.054-1.332 3.471-2.97 3.471-1.637 0-2.97-1.417-2.97-3.471 0-2.102 1.333-3.566 2.97-3.566z"}})])])
          )
        }
      }
    